import React from "react";
import Package1 from "./Package1"

function Package() {
  return <Package1 />
}
  
export default Package;